// 其它报表接口链接

// 积分发放日报
export const POINT_GRANT_DAILY = '/cmvip/reportApi/pointGrantDaily';
// 积分消耗日报
export const POINT_CONSUME_DAILY = '/cmvip/reportApi/pointConsumeDaily';
// 积分日报
export const POINT_DAILY = '/cmvip/reportApi/pointDaily';
// 事业部对账日报
export const DEPART_MENT_DAILY = '/cmvip/reportApi/departmentDaily';
// 积分发放日报-导出
export const POINT_GRANT_DAILY_EXPORT = '/cmvip/reportApi/exportPointGrantDaily';
// 积分消耗日报-导出
export const POINT_CONSUME_DAILY_EXPORT = '/cmvip/reportApi/exportPointConsumeDaily';
// 积分日报-导出
export const POINT_DAILY_EXPORT = '/cmvip/reportApi/exportPointDaily';
// 事业部对账日报-导出
export const DEPART_MENT_DAILY_EXPORT = '/cmvip/reportApi/exportDepartmentDaily';
// 任务看板数据概况
export const GET_TASK_HEAD = '/ccrm2/promote/board/taskHead';
// 任务看板折线图
export const GET_TASK_DETAIL = '/ccrm2/promote/board/taskDetail';
// 任务看板表格数据
export const GET_TASK_TABLE = '/ccrm2/promote/board/taskTable';
// 任务看板饼图
export const GET_TASK_PIE_CHART = '/ccrm2/promote/board/taskPieChart';
